

import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { ModalConfirmar } from "../../../../components/modals/Confirmar";
import type { BaseModalProps } from "../../../../components/modals/BaseModal";
import { notificacionError, notificacion } from "../../../../components/Alerts";
import { useQueryClient } from "@tanstack/react-query";

interface ModalConfirmarLanzarProps extends BaseModalProps {
	readonly idCiclo: number;
	readonly pedidosMarcados: Record<string, boolean>;
}
export function ModalConfirmarEliminar(props: ModalConfirmarLanzarProps) {
	const pedidos = Object.entries(props.pedidosMarcados).filter(([_id, marcado]) => marcado).map(([id]) => parseInt(id));
	const queryClient = useQueryClient();

	const onRevertirCiclo = () => {
		void revertirCiclo(props.idCiclo, pedidos)
			.then(success => {
				void queryClient.invalidateQueries({ queryKey: ["getCiclos"] });
				if (success) props.close();
			});
	};

	return (
		<ModalConfirmar
			show={props.show}
			close={props.close}

			title="Eliminar ciclo de fabrica"
			message="¿Desea cancelar el envio del ciclo a fábrica?"
			onConfirm={onRevertirCiclo}
			confirmText="Revertir ciclo"
			cancelText="Mantener ciclo"
		/>
	);
}
async function revertirCiclo(idCiclo: number, idsPedidos: number[]): Promise<boolean> {
	const response = await ComunicacionAjax.sendAjaxRequest<RevertirCicloResponse>("POST", "/api/v1/sacarDeCiclo", {
		"idCiclo": idCiclo,
		"idsPedidos": idsPedidos,
	});

	if (response.tipo != "exito") {
		notificacionError(response.message);
		return false;
	}

	notificacion(response.message);
	return true;
}
interface RevertirCicloResponse { tipo: string, message: string, cicloEliminado: boolean; }